"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _atom = require("atom");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _get = _interopRequireDefault(require("transmute/get"));

var _OptionTypes = require("UIComponents/types/OptionTypes");

var _react = _interopRequireWildcard(require("react"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _ReferenceResolverSearchType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverSearchType"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _utils = require("reference-resolvers/utils");

var _defaultFilterOptions = _interopRequireDefault(require("customer-data-reference-ui-components/defaults/defaultFilterOptions"));

var propertiesToOmit = ['open', 'onOpenChange', 'onSecondaryChange', 'onInvalidProperty', 'onCancel', 'requestOptions', 'optionFormatter', 'minimumSearchLength', 'searchCount', 'onTracking'];

function getUniqueOptions(options) {
  var hasValue = {};
  return options.filter(function (_ref) {
    var value = _ref.value;

    if (hasValue[value]) {
      return false;
    }

    hasValue[value] = true;
    return true;
  });
}

var propTypes = {
  autoload: _react.PropTypes.bool.isRequired,
  ButtonContent: _react.PropTypes.func,
  menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
  minimumSearchLength: _react.PropTypes.number.isRequired,
  multi: _react.PropTypes.bool,
  onChange: _react.PropTypes.func.isRequired,
  onOpenChange: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  optionFormatter: _react.PropTypes.func,
  options: _react.PropTypes.arrayOf(_OptionTypes.OptionType.isRequired),
  placeholder: _react.PropTypes.string,
  readOnly: _react.PropTypes.bool.isRequired,
  requestOptions: _react.PropTypes.object,
  resolver: _ReferenceResolverSearchType.default.isRequired,
  searchCount: _react.PropTypes.number.isRequired,
  searchDebounceTimeout: _react.PropTypes.number.isRequired,
  showTags: _react.PropTypes.bool,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired)])
};
var defaultProps = {
  autoload: true,
  minimumSearchLength: 0,
  options: [],
  readOnly: false,
  searchCount: 10,
  searchDebounceTimeout: 300,
  showTags: true
};
var initialState = {
  open: false,
  valueOptions: []
};

var defaultFormatter = function defaultFormatter(record) {
  return (0, _extends2.default)({}, _ReferenceRecord.default.toOption(record), {
    record: record
  });
};

var ReferenceInputEnumSearch =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ReferenceInputEnumSearch, _Component);

  function ReferenceInputEnumSearch(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ReferenceInputEnumSearch);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReferenceInputEnumSearch).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.handleLoadOptions = (0, _debounce.default)(props.searchDebounceTimeout, _this.handleLoadOptions);
    _this.prevSearchResult = null;
    _this.prevSearchValue = '';
    _this.searchAtom = null;
    _this.searchHandler = null;
    _this.searchHasMore = true;
    _this.state = initialState;
    _this.watchedReferenceAtoms = [];
    return _this;
  }

  (0, _createClass2.default)(ReferenceInputEnumSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          resolver = _this$props.resolver,
          value = _this$props.value,
          options = _this$props.options;
      this.loadCurrentValueOptions(resolver, value, options);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var resolver = nextProps.resolver,
          value = nextProps.value,
          options = nextProps.options;

      if (value !== this.props.value) {
        this.loadCurrentValueOptions(resolver, value, options);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      if (this.searchAtom) {
        (0, _atom.unwatch)(this.searchAtom, this.searchHandler);
      }

      this.watchedReferenceAtoms.forEach(function (referenceAtom) {
        (0, _atom.unwatch)(referenceAtom, _this2.handleValueOptionReferenceResolved);
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var extraOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = this.props.options;
      var valueOptions = this.state.valueOptions;
      return options.concat(valueOptions, extraOptions);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(_ref2) {
      var value = _ref2.target.value;
      this.setState({
        value: value
      });
    }
  }, {
    key: "handleLoadOptions",
    value: function handleLoadOptions(search, done) {
      var _this3 = this;

      // don't load options until the dropdown is showing
      if (!(this.props.open || this.state.open)) {
        return;
      }

      var _this$props2 = this.props,
          minimumSearchLength = _this$props2.minimumSearchLength,
          optionFormatter = _this$props2.optionFormatter,
          requestOptions = _this$props2.requestOptions,
          resolver = _this$props2.resolver,
          searchCount = _this$props2.searchCount;

      if (search.length < minimumSearchLength) {
        var options = getUniqueOptions(this.getOptions());
        done(null, {
          options: options,
          pagination: {
            hasMore: false,
            length: options.length
          }
        });
        return;
      }

      if (!this.searchHasMore && search.indexOf(this.prevSearchValue) === 0 && this.prevSearchResult) {
        done(null, this.prevSearchResult);
        return;
      }

      var nextSearchAtom = resolver.search((0, _extends2.default)({
        query: search,
        count: searchCount,
        offset: this.prevSearchValue === search && this.prevSearchResult && this.prevSearchResult.pagination.searchOffset || 0,
        nextCursor: this.prevSearchValue === search && this.prevSearchResult && this.prevSearchResult.pagination.nextCursor || null
      }, requestOptions));

      if (this.searchAtom) {
        (0, _atom.unwatch)(this.searchAtom, this.searchHandler);
      }

      this.searchAtom = nextSearchAtom;

      this.searchHandler = function (response) {
        if ((0, _utils.isResolved)(response)) {
          var hasMore = (0, _get.default)('hasMore', response);
          var offset = (0, _get.default)('offset', response);
          var results = (0, _get.default)('results', response);
          var total = (0, _get.default)('total', response); // support for cursor pagination; see SlackAPI for example

          var nextCursor = (0, _get.default)('nextCursor', response);
          var prevOptions = _this3.prevSearchValue === search && _this3.prevSearchResult && _this3.prevSearchResult.options || [];
          var formatter = typeof optionFormatter === 'function' ? optionFormatter : defaultFormatter;

          var _options = getUniqueOptions(_this3.getOptions(prevOptions.concat(results.map(formatter).toArray())));

          _this3.searchHasMore = hasMore;
          _this3.prevSearchValue = search;
          _this3.prevSearchResult = {
            // we need to prepend client-side options to every page
            // or it'll be unreachable
            options: _options,
            pagination: {
              hasMore: hasMore,
              length: total,
              offset: total ? total - (_options.length - _this3.props.options.length) : undefined,
              searchOffset: offset,
              nextCursor: nextCursor
            }
          };
          done(null, _this3.prevSearchResult);
        }
      };

      (0, _atom.watch)(this.searchAtom, this.searchHandler);
      var currentResult = (0, _atom.deref)(this.searchAtom);

      if (currentResult !== undefined) {
        this.searchHandler(currentResult);
      }
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange(evt) {
      var onOpenChange = this.props.onOpenChange;
      var value = evt.target.value;
      this.setState({
        open: value
      });

      if (this.searchAtom) {
        (0, _atom.unwatch)(this.searchAtom, this.searchHandler);
      }

      if (onOpenChange) {
        onOpenChange(evt);
      }
    }
  }, {
    key: "handleValueOptionReferenceResolved",
    value: function handleValueOptionReferenceResolved(reference) {
      var optionFormatter = this.props.optionFormatter;
      var formatter = typeof optionFormatter === 'function' ? optionFormatter : defaultFormatter;

      if ((0, _utils.isResolved)(reference)) {
        this.setState(function (prevState) {
          return {
            valueOptions: prevState.valueOptions.concat(formatter(reference))
          };
        });
      }
    }
  }, {
    key: "loadCurrentValueOptions",
    value: function loadCurrentValueOptions(resolver, value) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (!value) {
        return;
      }

      var optionValues = options.map(function (option) {
        return option.value;
      });
      var arrayValue = Array.isArray(value) ? value : [value];
      this.watchedReferenceAtoms.forEach(function (reference) {
        (0, _atom.unwatch)(reference, _this4.handleValueOptionReferenceResolved);
      });
      this.watchedReferenceAtoms = arrayValue.filter(function (id) {
        return optionValues.indexOf(id) === -1;
      }).map(function (id) {
        return resolver.byId(id);
      });
      this.watchedReferenceAtoms.forEach(function (reference) {
        (0, _atom.watch)(reference, _this4.handleValueOptionReferenceResolved);

        _this4.handleValueOptionReferenceResolved((0, _atom.deref)(reference));
      });
    }
  }, {
    key: "getButtonContent",
    value: function getButtonContent() {
      if (!this.props.showTags) {
        return this.props.ButtonContent;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          placeholder = _this$props3.placeholder;
      var transferrableProps = (0, _omit.default)(propertiesToOmit, this.props);
      return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, transferrableProps, {
        anchorType: "button",
        cache: null,
        filterOptions: _defaultFilterOptions.default,
        loadOptions: this.handleLoadOptions,
        onInputValueChange: this.handleInputChange,
        onOpenChange: this.handleOpenChange,
        ButtonContent: this.getButtonContent(),
        open: this.props.open || this.state.open,
        options: this.getOptions(),
        placeholder: placeholder,
        ref: "input",
        value: value,
        menuWidth: this.props.menuWidth
      }));
    }
  }]);
  return ReferenceInputEnumSearch;
}(_react.Component);

exports.default = ReferenceInputEnumSearch;
ReferenceInputEnumSearch.propTypes = propTypes;
ReferenceInputEnumSearch.defaultProps = defaultProps;
module.exports = exports.default;